// Environment configuration
export const env = {
  APP_NAME: import.meta.env.VITE_APP_NAME || "Pencom Frontend",
  APP_VERSION: import.meta.env.VITE_APP_VERSION || "1.0.0",
  API_BASE_URL:
    import.meta.env.VITE_API_BASE_URL ||
    (import.meta.env.DEV ? "/api" : "http://localhost:8000/api"),
  APP_ENV: import.meta.env.VITE_APP_ENV || "development",
  HIGHLIGHT_PROJECT_ID: import.meta.env.VITE_HIGHLIGHT_PROJECT_ID || "",
  LOG_LEVEL: import.meta.env.VITE_LOG_LEVEL || "info",
  IS_DEVELOPMENT: import.meta.env.DEV,
  IS_PRODUCTION: import.meta.env.PROD,
  REMITA_PUBLIC_KEY: import.meta.env.VITE_REMITA_PUBLIC_KEY || "",
  POSTHOG_KEY: import.meta.env.VITE_POSTHOG_KEY || "",
  POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com",
} as const;

export type Environment = typeof env;
